import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function ActStatus({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <div className="secTitle">
          <h5>1. Number of Complaints Officer designated in the district</h5>
        </div>

        <div className="row">
          <div className="col-lg-3">
            <div className="form-group">
              <label>Status</label>
              <input type="text" placeholder="Enter Status" />
            </div>
          </div>
          <div className="col-lg-3">
            <div className="form-group">
              <label>Remarks</label>
              <input type="text" placeholder="Enter Remarks" />
            </div>
          </div>
        </div>

        <div className="secTitle">
          <h5>
            2. Stigma and discrimination cases reported during the month
            (Describe)
          </h5>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <input type="text" placeholder="Description" />
            </div>
          </div>
        </div>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
